export default {
  fullscreen: 'Tela cheia',
  exitFullscreen: 'Sair da tela cheia'
}
